import React, { Component, Fragment } from 'react';
import { Link, NavLink } from 'react-router-dom';
import cardIconBackground from './../../img/card-icon-background.svg';
import phoneCompanyIcon from './../../img/phone-company-icon.svg';
import mobileIcon from './../../img/mobile-android.svg';
import { translate } from 'react-i18next';
import { request } from './../../../../config';
import categoryFilter from "./../../../../helpers/categoryFilter";
import backcellIcon from '../../img/bakcell.svg';
import PaymentModalSucces from '../../../../copms/Modal/PaymentModalSucces';
import PaymentModalError from '../../../../copms/Modal/PaymentModalError';
import Templates from '../Templates/TemplatesMini';
import Loading from './../../Loading/Loading';
import PaymentMethodIPS from '../../../../copms/Modal/PaymentMethodIPS';
import CreditPaymentCategory from '../../../../copms/Modal/CreditPaymentCategory';

class Payments extends Component {

    state = {
        categories: [],
        alt_categories: [
            {
                displayName: 'Bakcell',
            },
            {
                displayName: 'Azercell',
            }
        ],
        isLoading: true,
        searchVisibility: false,
        paymModalOpen: true,
        paymModalOpen: false
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let getCategoryListCustomerRequestBody = customerType == 'Juridical' ? {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            accountId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            accountId: this.props.match.params.id,
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }

        fetch(request("pg/getCategoryList" + customerType + 'V2', getCategoryListCustomerRequestBody))
            .then(res => res.text())
            .then((getCategoryListCustomerResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getCategoryListCustomerResponse = JSON.parse(getCategoryListCustomerResponseJSON);
                if (getCategoryListCustomerResponse.status.statusCode !== 1) {
                    if (getCategoryListCustomerResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    this.setState({ categories: getCategoryListCustomerResponse.categoryList })
                    this.setState({ isLoading: false });

                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    render() {
        let { categories, alt_categories, isLoading, searchVisibility, paymModalOpen } = this.state;
        let { updateAppState, t } = this.props;
        return (
            <Fragment>
                <CreditPaymentCategory onClose={() => this.setState({ paymModalOpen: false })} open={paymModalOpen} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('payments')}</h2>
                    </div>
                </div>
                {
                    isLoading ?
                        <div className="dashboard-container-main-section">
                            <Loading />
                        </div>
                        :
                        <div className="dashboard-container-main-section-vertical">
                            <PaymentModalSucces open={false} />
                            <PaymentModalError open={false} />
                            <div className="dashboard-payment-section-categorys">
                                <div className="dashboard-payment-section" style={{ borderTopRightRadius: 0, width: '65%' }} >
                                    <div className="dashboard-payment-section-header">
                                        <h3 className="dashboard-payment-section-header-title">{t('Category selection')}</h3>
                                        <button></button>
                                    </div>

                                    <ul className="dashboard-payment-section-categorys-cards">
                                        {
                                            categories.map(category => (
                                                category.categoryName === "CREDIT_OTHER_CARD" ?
                                                    <li className='d-flex align-items-center flex-column'>
                                                        <button onClick={() => this.setState({ paymModalOpen: true })}>
                                                            <img src={categoryFilter(category.categoryName)} className="dashboard-payment-section-content-icon" alt="categoryName" />
                                                        </button>
                                                        <p className="dashboard-payment-section-content-title">{category.displayName}</p>
                                                    </li> :
                                                    <li className='d-flex align-items-center flex-column'>
                                                        <NavLink to={`/dashboard/payment/${this.props.bonus ? 'bonus/' : ''}payments/categories/${category.categoryId}`}
                                                            activeClassName="active-link">
                                                            <img src={categoryFilter(category.categoryName)} className="dashboard-payment-section-content-icon" alt="categoryName" />
                                                        </NavLink>
                                                        <p className="dashboard-payment-section-content-title">{category.displayName}</p>
                                                    </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                                <div className="dashboard-payment-section dashboard-payment-section-right" style={{ borderTopLeftRadius: 0, backgroundColor: '#F8FAFB', width: '35%' }} id="operator_list">
                                    <div className="dashboard-payment-section-header dashboard-payment-section-header-redesign mx-3 p-0">
                                        <h3 className="dashboard-payment-section-header-title" style={{ marginLeft: '5px' }}>{t('Templates')}</h3>
                                        <button style={{ color: '#0179D2' }} onClick={() => this.setState({ searchVisibility: !this.state.searchVisibility })}>{this.state.searchVisibility ? 'Bağla' : 'Ətraflı axtarış'}</button>
                                    </div>
                                    {!isLoading && <Templates searchVisibility={searchVisibility} />}


                                    {/* <ul className="dashboard-payment-section-categorys-alts"> */}
                                    {/* <li>
                                        <Link to="/dashboard/payment/templates/new-template" className="dashboard-template-section-content-button">
                                            <div className="dashboard-template-section-content-button__left-side dashboard-template-section-content-button-icon-section__new">
                                            </div>
                                            <div className="dashboard-template-section-content-button__right-side">
                                                <p className="dashboard-template-section-content-title">{t("New templates")}</p>
                                            </div>
                                        </Link>
                                        </li> */}


                                    {/* {
                                            merchants.map((category, index) => (
                                                <li key={index}>
                                                    <Link to={`/dashboard/payment/${this.props.bonus ? 'bonus/' : ''}payments/categories/${this.props.match.params.id}/providers/${category.merchantId}`} onClick={()=>localStorage.setItem("additionalCodeParamType", category.additionalCodeParamType)}>
                                                        <img src={category.img} />
                                                        <p className="dashboard-payment-section-content-title">{category.displayName}</p>
                                                    </Link>
                                                </li>
                                            ))
                                        } */}
                                    {/* </ul> */}
                                </div>

                            </div>

                        </div>
                }
            </Fragment>
        )
    }
}


export default translate("translation")(Payments);